import { render, staticRenderFns } from "./CampaignPeriod.vue?vue&type=template&id=16796d3f&scoped=true"
import script from "./CampaignPeriod.vue?vue&type=script&lang=js"
export * from "./CampaignPeriod.vue?vue&type=script&lang=js"
import style0 from "./CampaignPeriod.vue?vue&type=style&index=0&id=16796d3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16796d3f",
  null
  
)

export default component.exports